import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function render({ theme }) {
  const button = document.querySelector(".c-god__button");
  const arrow = button.querySelector(".c-god__arrow");
  const gradient = button.querySelector(".c-god__gradient");
  const logo = button.querySelectorAll(".c-god__logo>*");

  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function () {
      let hover = gsap.timeline({ paused: true });
      hover
        .to(button, {
          duration: 0.2,
          width: "31.2rem",
        })
        .to(arrow, { display: "block" })
        .to(
          arrow,
          {
            duration: 0.3,
            ease: "Back.easeOut",
            scale: 1,
          },
          0.2
        )
        .to(gradient, { autoAlpha: 1, duration: 0.3 }, 0.2);

      button.addEventListener("mouseenter", () => {
        hover.play();
        gsap.to(button, {
          borderColor: "transparent",
          duration: 0.3,
        });
        gsap.to(logo, {
          color: theme.isLight() ? "white" : "",
          duration: 0.2,
          fill: theme.isLight() ? "white" : "",
        });
      });
      button.addEventListener("mouseleave", () => {
        hover.reverse();
        gsap.to(button, {
          borderColor: theme.isLight() ? "black" : "white",
          delay: 0.3,
          duration: 0.3,
        });
        gsap.to(logo, {
          color: theme.isLight() ? "black" : "",
          delay: 0.3,
          duration: 0.2,
          fill: theme.isLight() ? "black" : "",
        });
      });
    },
  });
}
